import { render, staticRenderFns } from "./DormUserDormUpdate.vue?vue&type=template&id=6ddd39b0&"
import script from "./DormUserDormUpdate.vue?vue&type=script&lang=js&"
export * from "./DormUserDormUpdate.vue?vue&type=script&lang=js&"
import style0 from "./DormUserDormUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DormUserDormUpdate.vue"
export default component.exports